
import { AuthMixin } from '@/mixins/AuthMixin';
import { AppRoute } from '@/router/routes';
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'impersonation-banner',
})
export default class ImpersonationBanner extends mixins(AuthMixin) {
  isExiting = false;

  async handleExit() {
    this.isExiting = true;
    try {
      await this.$store.dispatch('auth/stopImpersonation');
      this.$notify.success('Stopped impersonating');
      await this.$router.replace({ name: AppRoute.AdminUsers });
    } catch (e) {
      const apiMessage = e?.response?.data?.message;
      this.$notify.error({
        title: 'Could not stop impersonation',
        description: apiMessage || GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isExiting = false;
    }
  }
}
